import CardPadrao from './card/card-padrao';
import {AtividadeDto} from "../tipos/dto/atividade-dto";
import {Box, BoxProps, Text, Timeline, useProps} from "@mantine/core";
import {IconCircleDot, IconCircleMinus} from "@tabler/icons-react";

interface AtividadeProps extends BoxProps {
  titulo?: string,
  dados: AtividadeDto[],
  card?: boolean
}
const defaultProps: Partial<AtividadeProps> = {
    card: true,
};
export default function Atividade(props: AtividadeProps) {
    const { card } = useProps('Atividade', defaultProps, props);
    function getTimeLine() {
      if (props.dados.length === 0) return <Text c="dimmed" size="sm">Sem registros</Text>

      return <Timeline active={1} bulletSize={24} lineWidth={2}>
            {props.dados.map((v, k) => {
                if (!v) {
                    return <Timeline.Item key={k} bullet={<IconCircleMinus size={12} />} title="Sem atividade">
                        <Text c="dimmed" size="sm">Sem atividades registradas</Text>
                    </Timeline.Item>
                }
                const date = new Date(v.dataHora)
                const desc = v.descricao.split(' ')
                return (
                  <Timeline.Item key={k} bullet={<IconCircleDot size={12} />} title={desc.slice(0,3).join(' ')+'...'}>
                      <Text c="dimmed" size="sm">{desc.slice(3, desc.length).join(' ')} | por <b>{v.autor}</b></Text>
                      <Text size="xs" mt={4}>{date.toLocaleDateString()} às <b>{date.toLocaleTimeString()}</b></Text>
                  </Timeline.Item>
                );
            })}
        </Timeline>
    }
    if (card) {
        return <CardPadrao titulo={props.titulo ? props.titulo : 'Atividades recentes'} {...props}>{getTimeLine()}</CardPadrao>
    } else return <Box {...props}>{getTimeLine()}</Box>;


}